<style lang="less">
  @import "./css/common.less";
</style>
<template>
  <div class="fabric common-content">
    <navMenu></navMenu>
    <div class="content">
      <div class="banner-items">
        <img src="../assets/images/banner_Fabric.jpg">
        <div class="banner-title font-large">
          <span>FABRIC</span>
        </div>
      </div>
      <div class="text-content">
        <div class="pc-items">
          <ContactBox></ContactBox>
        </div>
        <div class="article">
          <div class="bread-crumbs">
            <span class="pointer" @click="goToIndex">HOME></span>
            <span>FABRIC</span>
          </div>
          <div class="article-content">
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              Men and women fashion wear fabric
            </div>
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              School uniform fabric</div>
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              Corporate wear Fabric
            </div>
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              Workwear fabric
            </div>
            <div class="items">
              <img src="../assets/images/arrow-right.png" />
              Health wear Fabric
            </div>
          </div>
          <div class="tips">We can ship the fabric to Australia, Fiji, Vietnam, Indonesia etc.</div>
        </div>
        <div class="mb-items">
          <ContactBox></ContactBox>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import NavMenu from '../components/navMenu'
import Footer from '../components/footer'
import ContactBox from '../components/contactBox'
export default {
  data () {
    return {
      // url: ''
    }
  },
  components: {
    NavMenu,
    Footer,
    ContactBox
  },
  methods: {
    goToIndex(){
      this.$router.push('/index')
    }
  },
  watch: {},
  mounted () {
    
  }
}
</script>
<style lang="less">
  .fabric{
    .content .text-content .article .article-content{
      .items{
        margin-bottom: 25px;
        color: #333;
        font-weight: bold;
        display: flex;
        align-items: center;
        img{
          margin-right: 10px;
        }
      }
    } 
    .article .tips{
      color: #666;
    }
  }
</style>
